import { types, IUserPreferences, UserPreferencesActionsType } from '../types/userPreferences'

export const initialState: IUserPreferences = {
  isLoading: false,
  isLoaded: false,
  byGroup: {},
}

export const userPreferences = (
  state = initialState,
  action: UserPreferencesActionsType
): IUserPreferences => {
  switch (action.type) {
    case types.SAVE_PREFERENCE__SUCCESS:
      return {
        ...state,
        byGroup: {
          ...state.byGroup,
          [action.groupId]: {
            ...state.byGroup[action.groupId],
            [action.preferenceData.fieldName]: action.preferenceData.fieldValue,
          },
        },
      }
    case types.GET_PREFERENCES__STARTED:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      }
    case types.GET_PREFERENCES__SUCCESS:
      return {
        isLoading: false,
        isLoaded: true,
        byGroup: action.userGroupsPreferences,
      }
    case types.GET_PREFERENCES__FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
      }
    case types.DELETE_PREFERENCE__SUCCESS:
      const userGroupPreferences = { ...state.byGroup[action.groupId] }
      delete userGroupPreferences[action.fieldName]
      return {
        ...state,
        byGroup: {
          [action.groupId]: userGroupPreferences,
        },
      }
    default:
      return state
  }
}
